(function () {
  'use strict';

  var TAB_ID_KEY = 'soundgas_tab_id';
  var TABS_KEY = 'soundgas_open_tabs';
  var CHECK_KEY = 'soundgas_location_checked';

  var HEARTBEAT_INTERVAL = 2000;
  var TAB_EXPIRY = 5000;

  /*Gabriele*/
  
  var tabId = sessionStorage.getItem(TAB_ID_KEY);

  if (!tabId) {
    tabId =
      Date.now().toString(36) +
      '-' +
      Math.random().toString(36).substring(2);

    sessionStorage.setItem(TAB_ID_KEY, tabId);
  }

  function getTabs() {
    try {
      return JSON.parse(
        localStorage.getItem(TABS_KEY) || '{}'
      );
    } catch (e) {
      return {};
    }
  }

  function saveTabs(tabs) {
    localStorage.setItem(
      TABS_KEY,
      JSON.stringify(tabs)
    );
  }

  function cleanTabs() {
    var tabs = getTabs();
    var now = Date.now();

    Object.keys(tabs).forEach(function (id) {
      if (now - tabs[id] > TAB_EXPIRY) {
        delete tabs[id];
      }
    });

    saveTabs(tabs);

    return tabs;
  }

  /*
   * Register this tab.
   */
  function registerTab() {
    var tabs = getTabs();

    tabs[tabId] = Date.now();

    saveTabs(tabs);
  }

  registerTab();

  /*Keep this tab registered while it is open.*/
  var heartbeat = setInterval(
    registerTab,
    HEARTBEAT_INTERVAL
  );

  /* When this tab leaves, remove it immediately.*/
  window.addEventListener('pagehide', function () {
    clearInterval(heartbeat);

    var tabs = getTabs();

    delete tabs[tabId];

    saveTabs(tabs);
  });

  /* Check what other Soundgas tabs exist.*/
  var tabs = cleanTabs();

  var otherSoundgasTabExists =
    Object.keys(tabs).some(function (id) {
      return id !== tabId;
    });

  /*
   * If another Soundgas tab exists,
   * this is simply another tab.
   * DO NOT run location detection.
   */

  if (otherSoundgasTabExists) {
    console.log(
      '[Soundgas] Another Soundgas tab is open. Skipping location detection.'
    );

    return;
  }

  /*
   * This is the only Soundgas tab.
   * Don't run repeatedly while this tab is
   * being refreshed/navigated.
   */

  if (
    sessionStorage.getItem(CHECK_KEY) === '1'
  ) {
    return;
  }

  /*
   * Mark this tab as checked.
   */

  sessionStorage.setItem(CHECK_KEY, '1');

  console.log(
    '[Soundgas] Checking visitor location...'
  );

  /* Detection*/

  fetch(
    '/browsing_context_suggestions.json?country[enabled]=true',
    {
      credentials: 'same-origin'
    }
  )
    .then(function (response) {

      if (!response.ok) {
        throw new Error(
          'Location request failed: ' +
          response.status
        );
      }

      return response.json();
    })
    .then(function (data) {

      console.log(
        '[Soundgas] Location response:',
        data
      );

      var detectedCountry =
        data.detected_values &&
        data.detected_values.country &&
        data.detected_values.country.handle;

      if (!detectedCountry) {
        console.warn(
          '[Soundgas] No detected country.'
        );
        return;
      }

      detectedCountry =
        detectedCountry.toUpperCase();

      console.log(
        '[Soundgas] Shopify detected:',
        detectedCountry
      );

      var form = document.querySelector(
        'form[action*="/localization"]'
      );

      if (!form) {
        console.warn(
          '[Soundgas] Localization form not found.'
        );
        return;
      }

      var input = form.querySelector(
        'input[name="country_code"]'
      );

      if (!input) {
        console.warn(
          '[Soundgas] country_code input not found.'
        );
        return;
      }

      var currentCountry =
        (input.value || '').toUpperCase();

      console.log(
        '[Soundgas] Current country:',
        currentCountry
      );

      /*Already correct.*/

      if (
        currentCountry === detectedCountry
      ) {
        return;
      }

      console.log(
        '[Soundgas] Switching:',
        currentCountry,
        '→',
        detectedCountry
      );

      input.value = detectedCountry;

      HTMLFormElement.prototype.submit.call(form);
    })
    .catch(function (error) {

      console.error(
        '[Soundgas] Location detection failed:',
        error
      );

    });

})();